module.exports = __webpack_public_path__ + "static/media/redpacket-open.725ae81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/redpacket-open.png
// module id = 599
// module chunks = 6